import { useEffect } from "react";
import { Route, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const PrivateRoute = ({ component: Component, ...rest }) => {
  const navigate = useNavigate();

  const globalState = useSelector((state) => state.centerOnboardReducer);

  useEffect(() => {
    if (!globalState?.isCenterOnboardLoggedIn) {
      navigate("/center-onboard-login");
    }
  }, []);

  return <Route {...rest} render={(props) => <Component {...props} />} />;
};

export default PrivateRoute;
